

import { DRAWER_MENU } from "../types";

export const setSelectedDrawerMenu = (selectDrawerMenu: any) => {
  
  return {
    type: DRAWER_MENU.DRAWER_MENU_SET_SELECTED,
    payload: {...selectDrawerMenu}
  }
}

export const clearSelectedDrawerMenu = () => {
  return {
    type: DRAWER_MENU.DRAWER_MENU_CLEAR_SELECTED
  }
}